import React from 'react';
import { useSnackbar } from 'notistack';
import { Typography } from '@mui/material';

export type DropFileConstraintsProps = {
    accept: string;
    maxMbSize?: number;
    onDrop: (event: React.DragEvent<HTMLElement>) => void;
};

export const useHandleDropConstraints = function ({
    accept,
    maxMbSize,
    onDrop,
}: DropFileConstraintsProps) {
    const { enqueueSnackbar } = useSnackbar();
    const stopDefaults = (e: React.DragEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    const handleDropConstraints = (event: React.DragEvent<HTMLElement>) => {
        stopDefaults(event);

        Array.from(event.dataTransfer.files).forEach((file) => {
            // console.log(file.size);
            if (maxMbSize !== undefined && file.size > maxMbSize * 1000000) {
                // console.log(maxMbSize);
                enqueueSnackbar(<Typography>Fichier trop lourd</Typography>, {
                    variant: 'error',
                });
                throw new Error('Fichier trop lourd');
            }
            // console.log(file.type);
            if (accept !== undefined && !accept.split(',').includes(file.type)) {
                // console.log(accept);
                enqueueSnackbar(<Typography>Format de fichier non compatible</Typography>, {
                    variant: 'error',
                });
                throw new Error('Format de fichier non compatible');
            }
        });

        onDrop(event);
    };

    return {
        handleDropConstraints,
    };
};
